module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_7.321df63c.png";